import { httpBus } from "@/api/index.js";

/**
 * 修改meter
 * @returns 
 */
export function update(data) {
  return httpBus.request("put", `/device/meter`, { data });
}

/**
 * 新增meter
 * @returns 
 */
export function add(data) {
  return httpBus.request("post", `/device/meter`, { data });
}

/**
 * 获取meter列表
 * @returns 
 */
export function list(pageNum, pageSize, stationId, unitId) {
  return httpBus.request("get", `/device/meter`, {
    data: {
      pageNum,
      pageSize,
      stationId,
      unitId
    }
  });
}

/**
 * 获取meter列表
 * @param {*} pageNum
 * @param {*} pageSize
 * @param {*} stationId
 * @param {*} unitId
 * @returns
 */
export function getMeterList({pageNum = 1, pageSize = 65535, stationId, unitId, meterType}) {
  return httpBus.request("get", `/device/meter/list`, {
    params: {
      pageNum,
      pageSize,
      stationId,
      unitId,
      meterType,
    }
  });
}


/**
 * 批量删除meter
 * @returns 
 */
export function del(meterIds) {
  return httpBus.request("delete", `/device/meter/${meterIds}`);
}

/**
 * 获取meter详细信息
 * @returns 
 */
export function get(meterId) {
  return httpBus.request("get", `/device/meter/${meterId}`);
}

/**
 * 查询虚拟电表
 * @returns 
 */
export function getVMeterList(
  stationId,
  meterName = "",
  pageSize = 65535,
  pageNum = 1
) {
  return httpBus.request("get", `/device/v2/virtual/meter/list`, {
    params: {
      stationId,
      meterName,
      pageSize,
      pageNum,
      type: 1,
    }
  });
}

/**
 * 添加虚拟表
 * @returns 
 */
export function postVMeter(stationId, meterName, addList, subList, uuid) {
  return httpBus.request("post", `/device/v2/virtual/meter`, {
    data: {
      stationId,
      meterName,
      addList,
      subList,
      uuid,
      type: 1,
    }
  });
}

/**
 * 修改虚拟表
 * @returns 
 */
export function putVMeter(id, stationId, meterName, addList, subList, uuid) {
  return httpBus.request("put", `/device/v2/virtual/meter`, {
    data: {
      id,
      stationId,
      meterName,
      addList,
      subList,
      uuid,
      type: 1,
    }
  });
}

/**
 * 删除虚拟表
 * @returns 
 */
export function deleteVMeter(id) {
  return httpBus.request("delete", `/device/v2/virtual/meter/${id}`);
}
